import { Assets } from "../assets";

export const modalLearnMore = {
	allGarden: [
		{
			image: Assets.learnMore.jardin_picnic.learngardenentrada1,
		},
		{
			image: Assets.learnMore.jardin_picnic.learngardenentrada2,
		},
	],
	gardenPicNic: [
		{
			image: Assets.learnMore.jardin_picnic.learngardenentrada1,
		},
		{
			image: Assets.learnMore.jardin_picnic.learngardenentrada2,
		},
	],
	gardenEden: [
		{
			image: Assets.learnMore.jardin_eden.learneden1,
		},
		{
			image: Assets.learnMore.jardin_eden.learneden2,
		},
	],
	gardenZapata: [
		{
			image: Assets.learnMore.jardin_picnic.learngardenentrada1,
		},
		{
			image: Assets.learnMore.jardin_picnic.learngardenentrada2,
		},
	],
	soundSpace: [
		{
			image: Assets.learnMore.espacio_sonoro.learnsound1,
		},
		{
			image: Assets.learnMore.espacio_sonoro.learnsound2,
		},
	],
	library: [
		{
			image: Assets.learnMore.bibloteca.learnlibrary1,
		},
		{
			image: Assets.learnMore.bibloteca.learnlibrary2,
		},
	],
	cafeteria: [
		{
			image: Assets.learnMore.cafeteria.learncafeteria1,
		},
		{
			image: Assets.learnMore.cafeteria.learncafeteria2,
		},
	],
	rectoria: [
		{
			image: Assets.learnMore.claustro.learnclaustro1,
		},
		{
			image: Assets.learnMore.claustro.learnclaustro2,
		},
	],
	culturalCenter: [
		{
			image: Assets.learnMore.centro_cultura.learncentro1,
		},
		{
			image: Assets.learnMore.centro_cultura.learncentro2,
		},
	],
	sportActivities: [
		{
			image: Assets.learnMore.actividades_deportivas.learnsport1,
		},
		{
			image: Assets.learnMore.actividades_deportivas.learnsport2,
		},
	],
};
